<template>
    <h2>
        <slot></slot>
    </h2>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
h2 {
    font-family: 'Pretendard', sans-serif;
    font-size: 50px;
    color: var(--black1);
    letter-spacing: -0.025em;
    font-weight: 700;
}
</style>
